<template>
  <div>
    <a class="card-wrapper">
      <div class="image-wrapper">
        <div class="image-sub-wrapper">
          <div class="image-container">
            <div class="image-background">
              <img :alt="this.title" class="avatar-pic" :src="`${this.url}`" />
            </div>
          </div>
        </div>
        <div class="title-container">
          <div class="title-row">
            <p class="card-title">{{ this.title }}</p>
          </div>
          <div>
            <slot name="sub_title" />
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "UserCard",
  props: {
    title: {
      type: String,
    },
    url: {
      type: String,
    },
    id: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>


<style scoped>
.card-wrapper {
  height: 100%;
  border-radius: 5px;
  margin-bottom: 15px;
}

.image-wrapper {
  display: grid;
  grid-template-columns: 85px 1fr;
  /* background: #171923; */
  background-color: #fafafa;
  padding: 12px;
  height: 100%;
  border-width: 1px;
  border-style: solid;
  border-image: initial;
  border-color: #e2e8f033;
  border-radius: 20px;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  transition: all 0.25s ease 0s;
}

.title-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  padding-left: 25px;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
}

.image-sub-wrapper > *:not(style) {
  overflow: hidden;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.image-sub-wrapper {
  position: relative;
  width: 85px;
  height: 85px;
}

.sub-title {
  color: #a0aec0;
  white-space: normal;
  width: 100%;
}

.wrapper {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(2, minmax(1px, 1fr));
  color: #444;
}

.box {
  background-color: #171923;
  color: #434a54;
  border-radius: 5px;
  padding: 20px;
  font-size: 150%;
}

.image-container {
  position: relative;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  box-shadow: rgb(244 220 132 / 10%) 0px 0px 20px 5px inset;
  border-radius: 20px;
}

.image-background {
  position: absolute;
  inset: 0px;
  font-size: 1.5rem;
  text-align: center;
}

.title-row {
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

a {
  color: #434a54;
  text-decoration: none;
}

.avatar-pic {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2),
    0 1rem 1rem -0.5rem rgba(0, 0, 0, 0.3);
  border-radius: 50%;
}
</style>